import './CopProductCatalog.scss';

import ProductCatalogSearch from './components/ProductCatalogSearch';
import ProductCatalogTabs from './components/ProductCatalogTabs';

export interface CategoryFamily {
  familyTitle: string;
  familyLink: string;
  familyDetailLink?: string;
}

export interface CategoryConfig {
  categoryTitle: string;
  families: CategoryFamily[];
}

function parseCategoriesJson(raw?: string): CategoryConfig[] {
  if (!raw) return [];
  try {
    const parsed: CategoryConfig[] = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export type CopProductCatalogProps = {
  enableSearch?: string;
  searchPlaceholder?: string;
  searchErrorMessage?: string;
  searchErrorGuidance?: string;
  categoriesJson?: string;
};

const CopProductCatalog = ({
  enableSearch,
  searchPlaceholder,
  searchErrorMessage,
  searchErrorGuidance,
  categoriesJson,
}: CopProductCatalogProps) => {
  const showSearch = enableSearch !== 'false';
  const categoriesConfig = parseCategoriesJson(categoriesJson);

  return (
    <div className="cop-product-catalog">
      {showSearch && <ProductCatalogSearch searchPlaceholder={searchPlaceholder} searchErrorMessage={searchErrorMessage} searchErrorGuidance={searchErrorGuidance} categoriesJson={categoriesConfig} />}
      <ProductCatalogTabs categoriesConfig={categoriesConfig} />
    </div>
  );
};

export default CopProductCatalog;

